// Wait for both DOM and theme to be ready
document.addEventListener('DOMContentLoaded', function() {
    // Wait for theme to load, then register HeaderSection for big-card-header
    if (typeof theme !== 'undefined' && theme.HeaderSection) {
        const bigCardSection = document.querySelector('[data-section-type="big-card-header"]');
        if (bigCardSection) {
            // Use the exact same HeaderSection that main headers use
            new theme.HeaderSection(bigCardSection);
        }
    } else {
        // Fallback - wait a bit for theme to load
        setTimeout(function() {
            if (typeof theme !== 'undefined' && theme.HeaderSection) {
                const bigCardSection = document.querySelector('[data-section-type="big-card-header"]');
                if (bigCardSection) {
                    new theme.HeaderSection(bigCardSection);
                }
            }
        }, 500);
    }
});